import axios from 'axios';

const SHOPIFY_APP_PROXY_LOGIN_URL = 'https://function-bun-production-99a1.up.railway.app';

Shopify.functions.getMember = async function getMember() {
  const customerEmail = window.customer?.email;
  if (!customerEmail) return;

  console.log("Getting member...");

  const url = `${SHOPIFY_APP_PROXY_LOGIN_URL}/fetch-third-party-data`;

  try {
    const response = await axios.post(
      url,
      {
        endpoint: `getMember?identifier=${encodeURIComponent(customerEmail)}`,
        method: "GET",
      },
      {
        withCredentials: true,
      }
    );

    const member = response.data;
    sessionStorage.setItem("member", JSON.stringify(member));
    if (!member) return;
    const event = new CustomEvent("member-updated");
    document.dispatchEvent(event);
    return member;
  } catch (error) {
    console.error("Failed to fetch member data:", error);
  }
};

Shopify.functions.getMemberFromStorage = function getMemberFromStorage() {
  const member = sessionStorage.getItem("member");
  if (!member) return;

  const memberData = JSON.parse(member);
  return memberData;
}


Shopify.functions.showMemberSections = function showMemberSections(member, element) {
  if (!element) element = document;
  const loyaltyElements = element.querySelectorAll('[data-loyalty-member]');

  loyaltyElements.forEach((element) => {
    const value = element.dataset.loyaltyMember;
    if ((value === 'true' && member) || (value === 'false' && !member)) {
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  });
}

Shopify.functions.getTransactions = async function getTransactions() {
  const customerEmail = window.customer?.email;
  if (!customerEmail) return;

  console.log("Getting transactions...");

  const url = `${SHOPIFY_APP_PROXY_LOGIN_URL}/fetch-third-party-data`;

  try {
    const response = await axios.post(
      url,
      {
        endpoint: `getTransaction?identifierKey=customerData:email&identifierValue=${encodeURIComponent(customerEmail)}`,
        method: "GET",
      },
      {
        withCredentials: true,
      }
    )

    const transactions = response.data;
    if (!transactions) return;
    return transactions;
  } catch (error) {
    console.error("Failed to fetch transaction data:", error);
  }
}

// Execute

Shopify.functions.getMember();